/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const topSearchForm = {
    isLoading: false,
    showButton: false,
    submitDisabled: true,
    /**
     * Handle product click
     *
     * @param product
     */
    handleProductClick(product) {
        const mse = window.magentoStorefrontEvents
        if (!mse) {
            window.location.href = product.url
            return
        }

        if (typeof this.ensureStorefrontInstanceCtx === 'function') {
            this.ensureStorefrontInstanceCtx()
        }

        mse.context.setSearchResults(
            mse.context.getSearchResults()
        )

        mse.publish.searchProductClick('search-bar', `${product.sku}`)

        // Timeout to prevent submission before event has fired.
        setTimeout(() => window.location.href = product.url, 500)
    },
    /**
     * search suggestion callback
     *
     * @param suggestion
     */
    searchSuggestion(suggestion) {
        this.$refs.searchInput.value = suggestion
        document.getElementById('search_mini_form').submit()
    },
    clearInput() {
        this.queryPhrase = ''
        this.showButton = false
        this.submitDisabled = true
        this.liveSearchError = null
        this.searchHasRun = false
        this.liveSearchProducts = []
        this.liveSearchSuggestions = []
        this.liveSearchCategories = []
        this.$refs.searchInput.focus()
    },
    markSearchPending() {
        this.searchHasRun = false
    },
    /**
     * search input callback
     *
     * @returns {Promise<void>}
     */
    async searchInputCallback() {
        try {
            this.isLoading = true
            this.showButton = false
            this.submitDisabled = false
            this.searchHasRun = false
            await this.getProducts()
        } catch (error) {
            console.error('searchInputCallback error:', error)
        } finally {
            this.isLoading = false

            if (this.queryPhrase !== '') {
                this.showButton = true
                this.submitDisabled = false
                this.searchHasRun = true
            } else {
                this.showButton = false
                this.submitDisabled = true
                this.searchHasRun = false
            }
        }
    }
}

export default topSearchForm
